import React from "react";
import styled from "styled-components";

import { useCartContext } from "../context/CartContext";
import { useProductsContext } from "../context/ProductsContext";
import { shuffle } from "../utils/helpers";
import Product from "./Product";
import SectionHeader from "./SectionHeader";

const ProductCarousel = (props: any) => {
  const { className, cart, title } = props;
  const { cartItems } = useCartContext();
  const { products, singleProduct } = useProductsContext();

  const currIds = cart
    ? cartItems.map((item) => item.id)
    : [singleProduct.id].concat(cartItems.map((item) => item.id));

  const recProducts = cart
    ? products.filter((product) => !currIds.includes(product.id))
    : products
        .filter((product) => !currIds.includes(product.id))
        .filter((product) => product.category === singleProduct.category);

  // shuffle products in place
  shuffle(recProducts);
  // get first 10 items
  const recProductsTrimmed = recProducts.splice(0, 10);

  return (
    <>
      {title && <SectionHeader title={title} fontSize={24} />}
      <Carousel className={className}>
        {recProductsTrimmed.map((item, i) => (
          <Item key={i} item={item} />
        ))}
      </Carousel>
    </>
  );
};

function Item(props: any) {
  return (
    <Card>
      <Product key={props.item.id} {...props.item} />
    </Card>
  );
}

const Card = styled.article`
  width: 16vw;
  height: 16vw;
  display: inline-block;
`;

const Carousel = styled.div`
  overflow-x: scroll;
  white-space: nowrap;

  article {
    margin: 0 1vw;
  }

  article:first-of-type {
    margin-left: 0;
  }

  article:last-of-type {
    margin-right: 0;
  }

  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #d8d8d8;
  }

  ::-webkit-scrollbar {
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #2c2c2c;
  }
`;

export default ProductCarousel;
